// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TORQm5FL {\n  color: var(--defaultBlack)\n}\n.TORQm5FL.rBS0JPxi {\n    color: var(--lightGrey);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"arrow": "TORQm5FL",
	"disabled": "rBS0JPxi"
};
export default ___CSS_LOADER_EXPORT___;
